import { styled, TableCell, TableRow, Box } from "@material-ui/core";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F6F5F5",
    color: "#627182",
    fontSize: "0.875rem",
    fontWeight: "bold",
    height: 60,
    fontFamily: "Poppins",
    width: "200px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    fontFamily: "Poppins",
    width: "100px"

  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: "#FFFFFF",
  height: 60,
  position: "relative",
  fontFamily: "Poppins",
}));

const StyledTableExpiry = styled(Box)(() => ({
  backgroundColor: "#FAE1E1",
  color: "#FF4E4E",
  width: 100,
  borderRadius: 8,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 30,
}));

const StyledTableJob = styled(Box)(({contractType}) => ({
      width: 100,
      borderRadius: 8,
      margin: 'auto',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "center",
      height: 30,
      background:
        contractType == "Internee"? "#DDD6FE":
        contractType == "Permanent"? "#D1FEEB":
        contractType == "Resignation"? "#FBF6E0":
        contractType == "Probationary"? "#DFF1FC":
        contractType == "Hourly"? "#D1FE4A":
        "none",
      color:
        contractType == "Internee"? "#9885F9":
        contractType == "Permanent"? "#2BD48D":
        contractType == "Resignation"? "#DEBE18":
        contractType == "Probationary"? "#50A7F8":
        contractType == "Hourly"? "#059357":
        "initial"
    })
);

export { StyledTableCell, StyledTableRow, StyledTableExpiry, StyledTableJob };
